export interface ContextVariableReference {
  display: string;
  id: string;
}

export interface ContextVariableRange extends ContextVariableReference {
  markupStart: number;
  markupStop: number;
  start: number;
  stop: number;
}

const CONTEXT_VARIABLE_MARKUP_PATTERN = /\{\{([^{}]+)\}\}/gu;

/**
 * Maps persisted context-variable markup ranges to their positions in the
 * display value. Display ranges use an exclusive `stop` index.
 */
export const getContextVariableRanges = (
  value: string,
  contextVariables: ContextVariableReference[],
): ContextVariableRange[] => {
  const contextVariablesById = new Map(
    contextVariables.map(contextVariable => [
      contextVariable.id,
      contextVariable,
    ]),
  );
  let removedMarkupLength = 0;

  return [...value.matchAll(CONTEXT_VARIABLE_MARKUP_PATTERN)].flatMap(match => {
    const markup = match[0];
    const id = match[1];
    const markupStart = match.index;
    const contextVariable = contextVariablesById.get(id);

    if (!contextVariable) {
      return [];
    }

    const displayLength = contextVariable.display.length + 1;
    const start = markupStart - removedMarkupLength;
    removedMarkupLength += markup.length - displayLength;

    return [
      {
        ...contextVariable,
        markupStart,
        markupStop: markupStart + markup.length,
        start,
        stop: start + displayLength,
      },
    ];
  });
};
